(function($) {
    'use strict';

    $(document).ready(function() {
        $('.home-blog-section').each(function() {
            var $section = $(this);
            var $slider = $section.find('.home-blog__slider');
            
            if (!$slider.length) return;

            $slider.slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 5000,
                infinite: true,
                dots: false,
                arrows: true,
                prevArrow: $section.find('.home-blog__nav-btn--prev'),
                nextArrow: $section.find('.home-blog__nav-btn--next'),
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        });
    });

})(jQuery);
